import { useState } from 'react';

import { Button } from '../button';
import { Dialog } from '../dialog';

const fundingAcknowledgmentCopy =
  'Support for the development of this tool was provided by the National Center for Advancing Translational Sciences of the National Institutes of Health under award number UM1TR004771. The content is solely the responsibility of the authors and does not necessarily represent the official views of the National Institutes of Health.';

export const FundingAcknowledgmentButton = ({
  className,
}: {
  className?: string;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={className}>
        <Button
          variant="text"
          onClick={() => setOpen(true)}
          className="text-black-primary font-semibold"
        >
          Funding Acknowledgment
        </Button>
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        title="CCTS Funding Acknowledgment"
      >
        <p className="text-black-primary text-sm leading-6">
          {fundingAcknowledgmentCopy}
        </p>
      </Dialog>
    </>
  );
};
